import { Box } from "@material-ui/core";
import SimpleCarousel from "Components/Carousels/SimpleCarousel";
import AdaptiveModal from "Components/modal/Modal/AdaptiveModal";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
// import { OVERVIEW, TARGET } from "src/constants/routeConstants";
import CarouselContent from "./CarouselContent";
import useStyles from "./styles";

const ObjectiveList = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const { objectiveList } = useWatch();
  const responsive = {
    0: { items: 1 },
    1024: { items: 1 },
  };

  const displayItem = (objectiveList || []).map((res, key) => (
    <CarouselContent
      key={key}
      objectives={res.objective}
      selectedObjective={res}
      objectiveDetail={res}
    />
  ));

  const handleClose = () => {
    props.setOpen(false);
  };

  const index = objectiveList.findIndex((res) => props?.openModalId === res.id);

  useEffect(() => {
    props?.openModalId && setCurrentIndex(index >= 0 ? index : 0);
  }, [props?.openModalId]);

  return (
    <div>
      <AdaptiveModal
        {...props}
        handleClose={handleClose}
        size="sm"
        title="My targets"
        // title={`Objectives (${
        //   (get(objectiveList, `${currentIndex}.objective`, []) || []).length
        // })`}
        // extraInfo={
        //   <Button
        //     data-testid="push"
        //     className="custom-btn"
        //     onClick={() => {
        //       history.push({
        //         pathname: `${TARGET}${OVERVIEW}/${objectiveList?.[currentIndex]?.id}`,
        //         state: { currentTab: "objective" }
        //       });
        //     }}>
        //     View details
        //   </Button>
        // }
        body={
          (displayItem || []).length ? (
            <Box className={classes.simpleCarousel} height="450px">
              {/* className={classes.companyTargetCarousel}> */}
              <SimpleCarousel
                responsive={responsive}
                data={displayItem}
                showActiveCount={true}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
            </Box>
          ) : null
        }
      />
    </div>
  );
};

export default ObjectiveList;
